// MealTypeIcon.js — SVG icons for Breakfast, Lunch, Dinner meal sections
import React from "react";

export function BreakfastIcon() {
  return (
    <div className="flex items-center pb-0.5 justify-center w-[20px] h-[20px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M8.33333 1.6665V3.33317M11.6667 1.6665V3.33317M13.3333 6.6665C13.5543 6.6665 13.7663 6.7543 13.9226 6.91058C14.0789 7.06686 14.1667 7.27882 14.1667 7.49984V14.1665C14.1667 15.0506 13.8155 15.8984 13.1904 16.5235C12.5652 17.1486 11.7174 17.4998 10.8333 17.4998H5.83333C4.94928 17.4998 4.10143 17.1486 3.47631 16.5235C2.85119 15.8984 2.5 15.0506 2.5 14.1665V7.49984C2.5 7.27882 2.5878 7.06686 2.74408 6.91058C2.90036 6.7543 3.11232 6.6665 3.33333 6.6665H15C15.8841 6.6665 16.7319 7.01769 17.357 7.64281C17.9821 8.26794 18.3333 9.11578 18.3333 9.99984C18.3333 10.8839 17.9821 11.7317 17.357 12.3569C16.7319 12.982 15.8841 13.3332 15 13.3332H14.1667M5 1.6665V3.33317"
          stroke="#0D0C07"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

export function LunchIcon() {
  return (
    <div className="flex items-center justify-center w-[20px] h-[20px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_1408_6195)">
          <path
            d="M13.3333 1.65967L11.4166 3.57633C10.9586 4.04366 10.702 4.67195 10.702 5.32633C10.702 5.98072 10.9586 6.60901 11.4166 7.07633L12.9166 8.57634C13.384 9.0344 14.0123 9.29098 14.6666 9.29098C15.321 9.29098 15.9493 9.0344 16.4166 8.57634L18.3333 6.65967M12.5 12.493L2.74997 2.743C2.41737 3.06888 2.15315 3.45785 1.97276 3.88713C1.79238 4.31641 1.69946 4.77736 1.69946 5.243C1.69946 5.70864 1.79238 6.1696 1.97276 6.59888C2.15315 7.02815 2.41737 7.41712 2.74997 7.743L8.83331 13.8263C9.41664 14.4097 10.5 14.4097 11.1666 13.8263L12.5 12.493ZM12.5 12.493L18.3333 18.3263M1.74997 18.1597L7.08331 12.9097M15.8333 4.15967L9.99997 9.993"
            stroke="#0D0C07"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1408_6195">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0 -0.00683594)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export function DinnerIcon() {
  return (
    <div className="flex items-center pb-0.5 justify-center w-[20px] h-[20px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_1408_6320)">
          <path
            d="M10.0001 3.48617V2.65283M10.0001 3.48617C8.45299 3.48617 6.96925 4.10075 5.87529 5.19471C4.78133 6.28867 4.16675 7.7724 4.16675 9.3195M10.0001 3.48617C11.5472 3.48617 13.0309 4.10075 14.1249 5.19471C15.2188 6.28867 15.8334 7.7724 15.8334 9.3195M12.8334 15.4862L15.5001 13.1528C15.6588 12.9996 15.8461 12.8792 16.0513 12.7983C16.2565 12.7175 16.4757 12.6779 16.6962 12.6818C16.9168 12.6857 17.1344 12.7329 17.3366 12.8209C17.5389 12.9089 17.7219 13.0358 17.8751 13.1945C18.0283 13.3532 18.1487 13.5405 18.2296 13.7457C18.3104 13.9509 18.35 14.1701 18.3461 14.3906C18.3423 14.6112 18.295 14.8288 18.207 15.0311C18.119 15.2333 17.9921 15.4163 17.8334 15.5695L14.8334 18.3195C14.2501 18.9862 13.4167 19.3195 12.5001 19.3195H9.16675C8.25008 19.3195 7.41675 18.9862 6.83342 18.3195L5.74842 17.0995C5.6703 17.0115 5.57444 16.9411 5.46715 16.8928C5.35986 16.8446 5.24356 16.8196 5.12592 16.8195H4.16675M1.66675 12.6528H11.6667C12.1088 12.6528 12.5327 12.8284 12.8453 13.141C13.1578 13.4535 13.3334 13.8775 13.3334 14.3195C13.3334 14.7615 13.1578 15.1854 12.8453 15.498C12.5327 15.8106 12.1088 15.9862 11.6667 15.9862H10.0001M3.33341 9.3195H16.6667M4.16675 12.6528V17.6528C4.16675 17.8738 4.07895 18.0858 3.92267 18.2421C3.76639 18.3984 3.55443 18.4862 3.33341 18.4862H1.66675"
            stroke="#0D0C07"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1408_6320">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0 0.986328)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

const MEAL_TYPE_ICONS = {
  Breakfast: BreakfastIcon,
  Lunch: LunchIcon,
  Dinner: DinnerIcon,
};

/**
 * Render the appropriate meal type icon
 * @param {string} mealType - "Breakfast" | "Lunch" | "Dinner"
 */
export default function MealTypeIcon({ mealType }) {
  const IconComponent = MEAL_TYPE_ICONS[mealType];
  return IconComponent ? <IconComponent /> : null;
}
